import React from 'react';
import { Route,Switch } from 'react-router'
import SignIn from '../containers/sign_in';
import Sign from '../containers/sign';

export default () => { 
    return (
        <Switch>
            <Route exact path={`/sign`} component={Sign} />
            <Route path={`/sign/sign-in`} component={SignIn} />
            <Route path={`/sign/sign-up`} component={SignIn} />
            <Route path={`/sign/reset`} component={SignIn} />
        </Switch>
    )
}


// WEBPACK FOOTER //
// ./src/pages/sign/routes/index.js